export const NAME_AND_CONTACT_PROGRESS_VALUE = 25;
export const NAME_AND_CONTACT_COMPLETION_FRACTION = "1/4";
export const NAME_AND_CONTACT_HEADER = "name-and-contact-header";
export const NAME_AND_CONTACT_VERIFICATION_HEADER =
  "name-and-contact-verification-header";
export const NAME_AND_CONTACT_VERIFICATION_CONTENT_1 =
  "name-and-contact-verification-content-1";
export const NAME_AND_CONTACT_VERIFICATION_QUESTION =
  "name-and-contact-verification-question";
export const NAME_AND_CONTACT_FIND_PROVIDER_CONTENT_2 =
  "name-and-contact-find-provider-content-2";
export const NAME_AND_CONTACT_FORM = "name-and-contact-form";
export const EMAIL_CARD_ID = "email-card";
export const EMAIL_ICON_ID = "email-icon";
export const PHONE_CARD_ID = "phone-card";
export const PHONE_ICON_ID = "phone-icon";
export const PREFERRED_CONTACT_ERROR = "preferredContact-error-id";
export const CARD_EMAIL_LABEL = "card-email-label";
export const CARD_PHONE_LABEL = "card-phone-label";
export const CARD_REQUIRED_ERROR = "card-required-error";
export const VERIFY_ACTION = "verify";
export const PHONE = "phone";
export const PHONE_NUMBER = "phoneNumber";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const DATE_OF_BIRTH = "dateOfBirth";
export const PREFERRED_CONTACT = "preferredContact";
